import Api from "../utils/axios";

export const ticketApis = {
  createTicket: (payload) => Api.post("user/create-ticket", payload),
  getAllTickets: (payload) => Api.post("user/get-all-tickets", payload),
  getTicketById: (id) => Api.get(`user/ticket/${id}`),
}

export const documentApi = {
    createDocument: (payload) => Api.post("master/create-document", payload,{
        headers: {
            "Content-Type": "multipart/form-data",
          },
    }),
    updateDocument: (payload, id) => Api.put(`master/update-document/${id}`, payload,{
        headers: {
            "Content-Type": "multipart/form-data",
          },
    }),
    getDocumentById: (id) => Api.get(`master/get-document/${id}`),
    getAllDocument: () => Api.get("master/get-all-document"),
    deleteDocument: (id) => Api.delete(`master/delete-document/${id}`)
  };


export const bankDetailApi = {
    createBankDetail: (payload) => Api.post("vendor/create-bank-detail", payload,{
        headers: {
            "Content-Type": "multipart/form-data",
          },
    }),
    updateBankDetail: (id,payload) => Api.put(`vendor/update-bank-detail/${id}`, payload,{
        headers: {
            "Content-Type": "multipart/form-data",
          },
    }),
    getBankDetailById: (id) => Api.get(`vendor/get-bank-detail/${id}`),
    // getAllDocument: () => Api.get("master/get-all-document"),
    deleteBankDetail: (id) => Api.delete(`master/delete-document/${id}`)
  };
  export const AdminContectApi ={
    getAdminContect: () => Api.get("vendor/get-all-admin-logo-settings"),
  }

  export const ArticlesApi={
    getArticlesDetails: ()=>Api.get("vendor/get-all-privacy-terms"),
  }